import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 18a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2z","key":"svg-0"}],["path",{"d":"M12 1a7 7 0 0 1 7 7c0 4.185 -3.297 9 -7 9s-7 -4.815 -7 -9a7 7 0 0 1 7 -7","key":"svg-1"}]]

const IconAirBalloonFilled = createReactComponent('filled', 'air-balloon-filled', 'AirBalloonFilled', __iconNode);

export default IconAirBalloonFilled;